export default {
 appName: 'Events Manager',
 siteName: 'FiestaisMadrid',
 siteURL: 'https://panel.fiestaismadrid.net',
 apiURI: 'https://panel.fiestaismadrid.net',
 googleMapsToken: 'AIzaSyBcrgqTqy3iserdlX8nm300dh8X5icRoyc',
 defaultPage: '/dashboard',
 defaultLanguage: 'es_ES'
}



// WEBPACK FOOTER //
// ./websources/config.js